import { tagged } from "@mirage/service-logging";
import { useEffect, useMemo, useState } from "react";
import { getDisplayStats, namespace, subscribeToDisplayStatsUpdates } from ".";

import type { Subscription } from "rxjs";
import type { Namespace } from ".";
import type { DisplayStatsByName } from "./service";

const logger = tagged("service-operational-metrics/hooks");

export function useOperationalMetrics(ns: string): Namespace {
  return useMemo(() => namespace(ns), [ns]);
}

export function useDisplayStatsByName() {
  const [statsByName, setStatsByName] = useState<DisplayStatsByName>();

  useEffect(() => {
    getDisplayStats()
      .then((s) => setStatsByName(s))
      .catch((e) => logger.error("Error fetching display stats", e));

    let subscription: Subscription | null = null;

    subscribeToDisplayStatsUpdates((s) => {
      setStatsByName(s);
    })
      .then((s) => (subscription = s))
      .catch((e) =>
        logger.error("Error subscribing to display stats updates", e),
      );

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  return statsByName;
}
